<template>
  <mp-modal
    :is-open="isOpen"
    :on-close="close"
    size="md"
    :close-on-esc="!preventClose"
    :close-on-overlay-click="!preventClose"
    z-index="calc(var(--zIndices-modal) + 10)"
  >
    <mp-modal-content>
      <mp-modal-header>{{ title }}</mp-modal-header>
      <mp-modal-close-button v-if="!preventClose" />
      <mp-modal-body>
        <mp-box text-align="center">
          <mp-box>
            <mp-image :src="content.img" w="216px" h="180px" />
            <mp-text font-size="2xl" font-weight="semibold" mb="2">{{ content.title }}</mp-text>
          </mp-box>

          <mp-box v-if="content.is_quota_info" my="2">
            <mp-box as="span" color="gray.600">Current quota: </mp-box><mp-box as="span" :color="color">{{ quotaData.active_user }}</mp-box
            >/{{ quotaData.limit }} users</mp-box
          >
          <mp-box color="gray.600">
            <template v-if="content.description === 'restricted'">You have not removed total user on performance to meet the quota.</template>
            <template v-else-if="content.description === 'exceed'">
              Manage the employees accordingly within {{ exceedData.grace_period_remaining_days }} days, or the system will have to restrict some
              actions.<br /><br />
              For more information please contact our support team.
            </template>
            <template v-else-if="content.description === 'equal'">
              To add more employees, please remove some of them or upgrade your quota please
              <mp-button as="a" variant="link" href="mailto:support@mekari.com" data-qa="settings-modal-warn-quota-link-support"
                >contact support</mp-button
              >
            </template>
          </mp-box>
        </mp-box>
      </mp-modal-body>
      <mp-modal-footer v-if="isSuperAdmin || hasAccess('manage-users')" gap="2">
        <mp-button v-if="!preventClose" variant="ghost" data-qa="settings-modal-warn-quota-btn-cancel" @click="close">Cancel</mp-button>

        <mp-button v-if="isRestricted || isExceed" variant="solid" data-qa="settings-modal-warn-quota-btn-manage" @click="goToManage"
          >Manage user</mp-button
        >
        <mp-button v-else variant="solid" data-qa="settings-modal-warn-quota-btn-upgrade" @click="upgrade">Upgrade quota</mp-button>
      </mp-modal-footer>
    </mp-modal-content>
    <mp-modal-overlay />
  </mp-modal>
</template>

<script>
import roleMixin from '@/mixins/role';

export default {
  name: 'ModalWarnQuota',
  mixins: [roleMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isExceed: {
      type: Boolean,
      default: false,
    },
    isRestricted: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    preventClose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    exceedData() {
      // got this from user-profile (fetched whenever load page) and also from submit APIs (create goal, cycle, etc)
      // it used for default quota data
      return this.$store.getters.getGrantAccess?.quotaData;
    },
    quotaData() {
      // in /manage-user/assign-role page we fetch latest quota data from /role-users/quota
      // so we will use that otherwise use exceedData as default
      return Object.keys(this.data)?.length ? this.data : this.exceedData;
    },
    content() {
      if (this.isRestricted) {
        return {
          title: 'Unable to access',
          img: this.$store.state.assets.restrictedImg,
          is_quota_info: false,
          description: 'restricted',
        };
      }
      return this.isExceed
        ? {
            title: 'Quota limit reached',
            img: this.$store.state.assets.processFailedImg,
            is_quota_info: true,
            description: 'exceed',
          }
        : {
            title: 'Quota limit reached',
            img: this.$store.state.assets.invalidImg,
            is_quota_info: true,
            description: 'equal',
          };
    },
    color() {
      return this.quotaData?.active_user > this.quotaData?.limit ? 'red.500' : 'dark';
    },
  },
  methods: {
    close() {
      this.$emit('update:isOpen', false);
    },
    goToManage() {
      if (this.$route.name !== 'settings_assign_role') this.$router.push({ name: 'settings_assign_role' });
      this.close();
    },
    upgrade() {
      this.$emit('request-quota');
      this.close();
    },
  },
};
</script>
